import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import GridLoading from './GridLoading';
const ProductsGridLoading = t0 => {
  const $ = _c(7);
  const {
    cardsCount,
    columnsOnDesktop: t1,
    columnsOnMobile: t2,
    itemContainerRef
  } = t0;
  const columnsOnDesktop = t1 === undefined ? "4" : t1;
  const columnsOnMobile = t2 === undefined ? "2" : t2;
  let t3;
  if ($[0] !== cardsCount) {
    t3 = <GridLoading cardsCount={cardsCount} />;
    $[0] = cardsCount;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== columnsOnDesktop || $[3] !== columnsOnMobile || $[4] !== itemContainerRef || $[5] !== t3) {
    t4 = <ProductCardGridUI columnsOnDesktop={columnsOnDesktop} columnsOnMobile={columnsOnMobile} limitWidth={false} containerRef={itemContainerRef}>{t3}</ProductCardGridUI>;
    $[2] = columnsOnDesktop;
    $[3] = columnsOnMobile;
    $[4] = itemContainerRef;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
ProductsGridLoading.propTypes = {
  cardsCount: PropTypes.number,
  columnsOnDesktop: PropTypes.oneOf(['1', '2', '3', '4', 'auto']),
  columnsOnMobile: PropTypes.oneOf(['1', '2']),
  itemContainerRef: PropTypes.object
};
export default ProductsGridLoading;